var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',{staticClass:"main-overview",attrs:{"id":"overviewBackground"}},[_c('platform-navigation',{staticClass:"main-nav"}),_c('router-view',{staticClass:"main-overview__body"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }